import React, { Component } from "react";
import "./SpotRow.styles.scss";
import Action from "../Action/Action";
import { Icon } from "react-materialize";
import BarLoader from "react-spinners/BarLoader";

class SpotRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assigned_to: [],
      //   selected_mdos: [],
    };
  }

  componentDidMount() {
    // console.log(`CDM at spotrow`)
  }

  removeMdo = (mdo) => {
    let removedList = this.state.assigned_to.filter((obj) => {
      return obj.id !== mdo.id;
    });

    this.setState({ assigned_to: removedList }, () => {
      // console.log(removedList)
      this.props.handleAssignments(this.props.data, this.state.assigned_to);
    });
  };

  handleMDOSelect = (item) => {
    this.setState({ assigned_to: [...this.state.assigned_to, item] }, () => {
      // console.log(this.state.assigned_to)
      this.props.handleAssignments(this.props.data, this.state.assigned_to);
    });
  };

  render() {
    return (
      <div className="spot-row-container">
        {this.props.loading ? (
          <BarLoader
            className="loader"
            color="#FFEDF6"
            // size={30}
            height={4}
            width="100%"
            loading={this.state.loading}
          />
        ) : (
          <>
            <div className="spot">
              <span className="spot-name">{this.props.data}</span>
            </div>
            <div className="assigned-to">
              {this.state.assigned_to.length < 1 && (
                <span className="not-assigned">
                  No one has been assigned yet.
                </span>
              )}

              {this.state.assigned_to.length > 0 &&
                this.state.assigned_to.map((mdo, index) => (
                  <div key={index} className="mdo-chip">
                    <span className="mdo-name">{mdo.name}</span>
                    <div
                      onClick={() => this.removeMdo(mdo)}
                      className="remove-icn"
                    >
                      <Icon right>close</Icon>
                    </div>
                  </div>
                ))}
            </div>

            <Action
              mdoList={this.props.mdoList}
              mdoid={this.props.mdoid}
              handleMDOSelect={this.handleMDOSelect}
            />
          </>
        )}
      </div>
    );
  }
}

export default SpotRow;
